import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { LinkContainer } from 'react-router-bootstrap';

import UserAvatar from 'components/user/UserAvatar';
import LanguageSelect from 'containers/ui/select/LanguageSelect';

import 'style/components/ui/layout/nav/header-settings.scss';
import {stopPropagation} from 'util/utils';

/** Component to render the header bar of the application */
class HeaderSettings extends Component {

    static propTypes = {
        title:     PropTypes.string, // The title to show in the app header
        pageTitle: PropTypes.string, // The title to show in the browser header
        user:      PropTypes.object, // The logged user
        onLogout:  PropTypes.func, // Listener when the user does logout
        onClick:   PropTypes.func // Listener when the item was clicked
    };

    renderContent() {
        const {user} = this.props;

        return (
            <LinkContainer to="/my/profile">
                <span className="header-settings-user-content">
                    <UserAvatar
                        firstName={user.firstName}
                        lastName={user.lastName}
                        email={user.email}
                        size={32}
                    />
                    <span className="header-settings-user-name">
                        {user ? user.firstName : 'Loading...'}
                    </span>
                </span>
            </LinkContainer>
        );
    }

    render() {
        const {onClick} = this.props;

        return (
            <div className="header-settings" onClick={onClick}>
                <div className="header-settings-user">
                    {this.renderContent()}
                </div>
                <div className="header-settings-language" onClick={stopPropagation}>
                    <LanguageSelect />
                </div>
            </div>
        );
    }
}

export default injectIntl(HeaderSettings);



// WEBPACK FOOTER //
// ./src/components/ui/layout/HeaderSettings.jsx